import Vue from "vue";
import Router from "vue-router";

//Admin Routes
// import Home from "./views/Home.vue";
import Error from "./views/Error.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import TakeExam from "./views/TakeExam.vue";
import AddQuestion from "./views/AddQuestion.vue";
import Users from "./views/Users.vue";
import Results from "./views/Results.vue";
import Test from "./views/Test.vue";

Vue.use(Router);

//   base: process.env.BASE_URL,
const routes = [
  {
    path: "/",
    name: "home",
    component: Login,
  },
  {
    path: "/yahweh2021",
    name: "test",
    component: Test,
  },
  {
    path: "/login",
    name: "exam-login",
    component: Login,
  },
  {
    path: "/register/2026",
    name: "exam-register",
    component: Register,
  },
  { path: "/list", name: "list", component: Users },
  { path: "/exam/results", name: "results", component: Results },
  {
    path: "/exam/take",
    name: "exam-take",
    component: TakeExam,
  },
  {
    path: "/admin/question/add",
    name: "add-question",
    component: AddQuestion,
  },
  {
    path: "*",
    name: "NotFound",
    component: Error,
  },
];

const router = new Router({
  mode: "history",
  routes,
  scrollBehavior: function (to) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
